import type {KeyValueStorageInterface} from 'aws-amplify/utils';
import {Preferences} from '@capacitor/preferences';

export class AmplifyPreferencesStorage implements KeyValueStorageInterface {
  async setItem(key: string, value: string): Promise<void> {
    await Preferences.set({key, value});
  }

  async getItem(key: string): Promise<string | null> {
    const {value} = await Preferences.get({key});
    if (value != null) return value;

    const legacy = this.readLocalStorage(key);
    if (legacy != null) {
      await Preferences.set({key, value: legacy});
      this.removeLocalStorage(key);
      return legacy;
    }

    return null;
  }

  async removeItem(key: string): Promise<void> {
    await Preferences.remove({key});
    this.removeLocalStorage(key);
  }

  async clear(): Promise<void> {
    await Preferences.clear();
  }

  private readLocalStorage(key: string): string | null {
    try {
      return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  }

  private removeLocalStorage(key: string): void {
    try {
      if (typeof window !== 'undefined') window.localStorage.removeItem(key);
    } catch {
      // ignore
    }
  }
}
